import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import {
  Popover, PopoverContent, PopoverTrigger,
} from "@/components/ui/popover";

export function NotificationBell() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } catch { /* noop */ }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);

  const unread = items.filter((i) => !i.read).length;

  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    setItems((prev) => prev.map((i) => (i.id === id ? { ...i, read: true } : i)));
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell" className="relative p-2 rounded-full hover:bg-stone-100 transition-colors">
          <Bell className="w-5 h-5 text-stone-700" />
          {unread > 0 && (
            <span data-testid="notification-count" className="absolute -top-0.5 -right-0.5 bg-orange-700 text-white text-[10px] font-semibold min-w-[18px] h-[18px] rounded-full flex items-center justify-center px-1">
              {unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 rounded-2xl overflow-hidden">
        <div className="px-4 py-3 border-b border-stone-200 font-heading font-semibold text-stone-900">Notifications</div>
        <div className="max-h-96 overflow-y-auto" data-testid="notification-list">
          {items.length === 0 && <p className="p-4 text-sm text-stone-500">No notifications yet.</p>}
          {items.map((n) => (
            <button
              key={n.id}
              onClick={() => markRead(n.id)}
              className={`w-full text-left px-4 py-3 border-b border-stone-100 hover:bg-stone-50 transition-colors ${n.read ? "opacity-60" : ""}`}
            >
              <p className="text-sm text-stone-800 leading-snug">{n.message}</p>
              <span className="text-xs text-stone-400">{new Date(n.created_at).toLocaleString()}</span>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
